module.exports = __webpack_public_path__ + "assets/QualidadeMonitorada.374dad33a485e91127fc5661bae176ff.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/QualidadeMonitorada.png
 ** module id = 479
 ** module chunks = 0
 **/